export const validateTextField = (value: string) => {
  const trimmedValue = value.trim();
  if (trimmedValue.length === 0) {
    return false;
  } else {
    return true;
  }
};
